import { ButtonProps as MuiButtonProps, default as MuiButton } from '@mui/material/Button';
import { combineCls, fontSize, textTransform, twCls } from '@/style';

export type GhostButtonProps = MuiButtonProps;

export const GhostButton = ({ children, className, ...rest }: GhostButtonProps): JSX.Element => {
  return (
    <MuiButton
      variant="text"
      {...rest}
      className={combineCls(twCls(textTransform('normal-case'), fontSize('text-base')), className)}
    >
      {children}
    </MuiButton>
  );
};
